import type { OptionsMap } from '@openx/types/options.ts';
import type { RetargetingFormState } from '@openx/types/targeting/retargeting.ts';
import { noop } from '@openx/utils/noop.ts';
import { useTranslation } from 'react-i18next';
import {
  TargetingDropdownSection,
  type TargetingDropdownSectionProps,
} from '../shared/ReadOnlyTargetingDropdown/TargetingDropdownSection.tsx';
import type { TargetingItemsProps } from '../types.ts';
import { SegmentListDisplay } from './components/SegmentListDisplay.tsx';

type FormPreviewItemsProps = TargetingItemsProps<RetargetingFormState> &
  TargetingDropdownSectionProps & {
    onClear: () => void;
    isLoading?: boolean;
    options?: OptionsMap;
  };

export const FormPreviewItems = ({
  targetingParams,
  readonly = true,
  onClear = noop,
  onOpenDrawerClick,
  onRemove,
  isDisabled,
  optionsCount,
  disabledReasonMessage,
  isLoading = false,
  options,
}: FormPreviewItemsProps) => {
  const { t } = useTranslation();

  if (!targetingParams.segment_id) {
    return null;
  }

  return (
    <TargetingDropdownSection
      name={t('Retargeting')}
      hideButtons={!readonly}
      isEmpty={false}
      onOpenDrawerClick={onOpenDrawerClick}
      onRemove={onRemove}
      isDisabled={isDisabled}
      hasOptionsSelected={!!optionsCount && optionsCount > 0}
    >
      <SegmentListDisplay
        segment={targetingParams}
        readonly={readonly}
        onClear={onClear}
        disabledReasonMessage={disabledReasonMessage}
        isLoading={isLoading}
        options={options}
      />
    </TargetingDropdownSection>
  );
};
